import { defineStore } from 'pinia'
import { ref } from 'vue'
import {
  getAllProductSettings,
  updateProductConfig,
  getVehicleStockCount,
} from '@/api'
import type { ISettings } from '@/types'
import { getAccountId } from '@/utils'

export const useSettingsStore = defineStore('settings', () => {
  const placements = ref()

  const loading = ref(false)
  const error = ref<Error | null>(null)
  const initialized = ref(false)
  const selectedMakeToEdit = ref<string | null>(null)
  const selectedModelToEdit = ref<string | null>(null)

  // const accountId = getAccountId()
  const accountId = ref<string>(getAccountId())
  const productId = 'jellybeans'

  const updateSettings = async (newSettings: ISettings) => {
    await updateProductConfig(accountId.value, productId, newSettings) // Push settings to JAM API
  }

  const fetchSettings = async (accountId: string) => {
    if (initialized.value) return

    loading.value = true
    error.value = null

    try {
      placements.value = await getAllProductSettings(accountId, productId)

      if (placements.value == null) {
        error.value = new Error('Failed to fetch settings')
        console.error('Failed to fetch settings')
        return
      }

      initialized.value = true
    } catch (err) {
      error.value =
        err instanceof Error ? err : new Error('Unknown error occurred')
      throw error.value
    } finally {
      loading.value = false
    }
  }

  function getDefaultPlacementSettings(): ISettings {
    return {
      theme: 'light',
      sort: 'desc',
      imageType: 'front34',
      viewMode: 'grid',
      filter: {},
      vehicleNameType: 'Model',
      baseUrl: '',
      usedDrag: false,
      showVehicleCount: true,
      item: {
        verticalGap: '20px',
      },
      image: {
        width: '100%',
        height: 'auto',
      },
      label: {
        color: '#000000',
        hoverColor: '#FF0000',
        typography: {
          fontSize: '14px',
          fontWeight: 'normal',
          lineHeight: '1.5em',
        },
      },
      callToAction: {
        label: 'View Details',
        link: '/vehicle/{{vin}}',
        color: '#000',
        typography: {
          fontSize: '14px',
          fontWeight: 'normal',
          lineHeight: '1.5em',
        },
        arrow: {
          backgroundColor: '#000000',
          color: '#FF0000',
          containerSize: '30px',
          iconSize: '30px',
        },
      },
      slider: {
        arrow: {
          color: '#000000',
          backgroundColor: '#FFFFFF',
          size: '30px',
        },
      },
    }
  }

  const getVehicleStockData = async () => {
    await getVehicleStockCount()
  }

  const resetError = () => {
    error.value = null
  }
  return {
    // State
    accountId,
    loading,
    error,
    initialized,
    placements,
    selectedMakeToEdit,
    selectedModelToEdit,

    // Actions
    updateSettings,
    fetchSettings,
    resetError,
    getVehicleStockData,
    getDefaultPlacementSettings,
  }
})
